import React from 'react';
import { Icon } from '../../../../../../core/components';
import { DataTable } from '../../../../../../core/components/Table/types/DataTable';
import { DataTableHeader } from '../../../../../../core/components/Table/types/DataTableHeader';
import { DocumentItem } from '../types/DocumentItem';

const DocumentsTableConfigurator = {
  getTableColumns: (
    table: DataTable<DocumentItem>,
    downloadDocument: (documentId: string) => void
  ) => {
    let columns: DataTableHeader[] = [];

    if (table.headers != null) {
      columns = table.headers.map((h) => ({
        ...h,
        CssClassNames: `${!h.isVisible && 'hide-d'} ${
          !h.isVisibleOnMobile && 'hide-m'
        }`,
      }));
      DocumentsTableConfigurator.configureActions(columns, downloadDocument);
      return columns;
    }
    return columns;
  },
  
  configureActions: (
    columns: DataTableHeader[],
    downloadDocument: (documentId: string) => void
  ) => {
    const column = columns.find(
      (x: DataTableHeader) => x.columnName === 'DocumentId'
    );
    if (column) {
      column.formatter = (value: any, rowItem: DocumentItem) =>
      DocumentsTableConfigurator.actionsRowData(rowItem, downloadDocument);
    }
  },
  
  actionsRowData: (
    rowItem: DocumentItem,
    downloadDocument: (documentId: string) => void
  ) => {
    return rowItem.DocumentId ? (
      <Icon
        iconVariant={Icon.Variants.FontAwesome}
        icon="fas fa-file-alt"
        onClick={() => downloadDocument(rowItem.DocumentId)}
        dataCy={`download-document-${rowItem.FileName}`}
        ariaLabel={`download-document`}
      />
    ) : null;
  }
}

export default DocumentsTableConfigurator;
